import NavCard from './NavCard';
import Navigation from './Navigation';

export default function DrawerContent() {
  return (
    <div className="flex flex-col overflow-y-auto" style={{ height: 'calc(100vh - 70px)' }}>
      <Navigation />
      {/* <NavCard /> */}
    </div>
  );
}
